/**
 * --- External Imports ---
 */
import { Field, Input } from "@ngt/forms-core";
import { FC, useMemo } from "react";

/**
 * --- Internal Imports ---
 */
import { DropdownFormField } from "../../../../api/dtos/dtos";
import InputDropdownField, { ISelectItem } from "../InputDropdownField";
import TextFieldControlLabel from "../labels/TextFieldControlLabel";
import { IFormFieldComponentProps } from "../types/FieldTypes";
import FieldErrors from "../utils/FieldErrors";


/**
 * --- Dropdown Component ---
 */
const FormFieldDropdown: FC<IFormFieldComponentProps<DropdownFormField>> = ({
    field,
    form
}) => {

    const options = useMemo(() => {
        return field.dropdownOptions?.map(x => {
            return {
                id: x.value,
                name: x.title
            } as ISelectItem<number>;
        });
    }, [field]);

    return (
        <TextFieldControlLabel 
            field={field}
            control={
                <Field propertyPath={`${form.name}.${field.name}`}>
                    <FieldErrors />
                    <Input 
                        fullWidth
                        size="small"
                        component={InputDropdownField}
                        options={options}
                        nullOption={field.nullOption ?? true}
                    />
                </Field>
            }
        />
    );
}

export default FormFieldDropdown;